// packages/shared/src/catalog/printZones.ts
//
// Print Area Location registry — canonical print-zone codes for vendor
// product registration (Phase 7 Amendment #6).
//
// Export pattern mirrors enums.ts: `as const` tuple → derived union → Zod
// schema. Node-pure (no Fastify / Mongoose imports) — safe in Vite client
// bundles. Imported by:
//   - apps/api  → import-excel validation (productSubmitService) + the
//                 GET /vendor/products/print-zones endpoint.
//   - apps/vendor → FileImporter "allowed values" hint + download template.
//
// GRAY-AREA resolution (blueprint task-02): the Print Area Location
// dropdown source has two candidates —
//   (a) Phase 2 catalog blueprint area codes (when a product is blueprint-linked), or
//   (b) this global static registry.
// The Excel import path is NOT blueprint-linked at registration time, so it
// uses this static enum. FORWARD HOOK: when a future amendment links Excel
// rows to a blueprint, swap the source to the blueprint's `areas[].code`
// vocabulary (see apps/api/src/modules/catalog/blueprints/area.subschema.ts).
import { z } from 'zod';
// ---------------------------------------------------------------------------
// PRINT_ZONES — common decoration placement zones. Stable codes (snake_case);
// human labels live in PRINT_ZONE_LABELS so the wire value never translates.
// ---------------------------------------------------------------------------
export const PRINT_ZONES = [
    'front',
    'back',
    'left_chest',
    'right_chest',
    'left_sleeve',
    'right_sleeve',
    'hood',
    'pocket',
    'neck_label',
    'full_front',
    'full_back',
    'all_over',
];
export const PrintZoneSchema = z.enum(PRINT_ZONES);
/** Human display labels (en). FE may localize further via i18n. */
export const PRINT_ZONE_LABELS = {
    front: 'Front',
    back: 'Back',
    left_chest: 'Left Chest',
    right_chest: 'Right Chest',
    left_sleeve: 'Left Sleeve',
    right_sleeve: 'Right Sleeve',
    hood: 'Hood',
    pocket: 'Pocket',
    neck_label: 'Neck Label',
    full_front: 'Full Front',
    full_back: 'Full Back',
    all_over: 'All Over',
};
//# sourceMappingURL=printZones.js.map